import { sendTeaCommEvent } from 'lib/tea-analyze'
import { ArticleCardContext } from 'Components/ugc/article-card'
import React, { useContext } from 'react'

interface IProps {
  text: string
  confirmBtnText?: string
  cancelBtnText?: string
  onButtonClick: (type: 'confirm' | 'cancel') => void
}

const ModalConfirmUponSelf = ({
  text,
  onButtonClick,
  cancelBtnText,
  confirmBtnText,
}: IProps) => {
  const { inheritNewCard } = useContext(ArticleCardContext)
  return (
    <div className="confirm-wrapper">
      <div className="text">{text}</div>
      <div className="action">
        <span
          className="delete-btn"
          onClick={() => {
            inheritNewCard &&
              sendTeaCommEvent('click_del_comment_window_btn', {
                button_name: confirmBtnText || '删除',
              })
            onButtonClick('confirm')
          }}
        >
          {confirmBtnText || '删除'}
        </span>
        <span
          className="cancel-btn"
          onClick={() => {
            inheritNewCard &&
              sendTeaCommEvent('click_del_comment_window_btn', {
                button_name: cancelBtnText || '取消',
              })
            onButtonClick('cancel')
          }}
        >
          {cancelBtnText || '取消'}
        </span>
      </div>
      <style jsx>
        {`
          .confirm-wrapper {
            position: absolute;
            bottom: 27px;
            left: -64px;
            width: 160px;
            height: 100px;
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
            background-color: white;
            z-index: 1;
          }
          .confirm-wrapper::after {
            content: '';
            position: absolute;
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-style: solid;
            border-color: white transparent transparent transparent;
            border-width: 6px 6px;
          }
          .text {
            position: relative;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            color: #1f2129;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 60px;
          }
          .text::after {
            position: absolute;
            bottom: -1px;
            content: '';
            width: 160px;
            height: 1px;
            background-color: #e6e8f2;
          }
          .action {
            display: flex;
            width: 100%;
            height: 40px;
          }
          .delete-btn::after {
            position: absolute;
            right: -0.5px;
            top: 50%;
            transform: translateY(-50%);
            content: '';
            width: 1px;
            height: 12px;
            background-color: #e6e8f2;
          }
          .cancel-btn,
          .delete-btn {
            position: relative;
            display: inline-flex;
            width: 50%;
            height: 100%;
            color: #205be6;
            font-size: 14px;
            line-height: normal;
            align-items: center;
            justify-content: center;
          }
        `}
      </style>
    </div>
  )
}

export default ModalConfirmUponSelf
